import { styled as muiStyled } from '@mui/material'

export const ReportsContainer = muiStyled('div')`
    display: flex;
    flex-direction: column;
    background: var(--cui-body-bg);
    padding: 16px;
    border-radius: 7px;
    // overflow: auto;
    `

export const ReportsTableContainer = muiStyled('div')(
  ({ theme }) => `
  overflow-x: auto;
      .min-width-lg{
            display: flex;
      align-items: baseline;
        width: max-content;
      }
    `,
)

export const ReportsTableItem = muiStyled('div')(
  ({ theme, columns = 5, header = false }) => `
    display: grid;
    grid-template-rows: repeat(${columns}, minmax(0,50px));
    ${header && `background: ${theme.palette.mode === 'dark' ? '#2f2e4b' : '#eeeeee'};`}
    .reports-header {
      display: flex;
      font-weight: 600;
      padding: 0px 10px;
      align-items:center;
      width: 250px;
    }
    .divider-top {
        border-top: 1px solid ${theme.palette.mode === 'dark' ? '#2f2e4b' : '#d4d4d4'};
    }
    .divider-bottom {
        border-bottom: 1px solid ${theme.palette.mode === 'dark' ? '#504e81' : '#d4d4d4'};
    }

    
    .reports-top-header {
      display: flex;
      font-weight: 600;
      padding: 0px 10px;
      justify-content: center;
      align-items:center;
      width: 350px;
      border-bottom: 1px solid ${theme.palette.mode === 'dark' ? '#2f2e4b' : '#ababab'};
      border-right: 1px solid ${theme.palette.mode === 'dark' ? '#2f2e4b' : '#ababab'};
      border-top: 1px solid ${theme.palette.mode === 'dark' ? '#2f2e4b' : '#ababab'};
    }

    .report-item{
      padding: 0px 10px;
      width: 350px;
      border-right: 1px solid ${theme.palette.mode === 'dark' ? '#2f2e4b' : '#ababab'};
      border-bottom: 1px solid ${theme.palette.mode === 'dark' ? '#2f2e4b' : '#eeeeee'};
      text-align: center;
      display:flex;
      align-items:center;
      justify-content:center;
    }
    .report-sub-item{
      padding: 0px 10px;
      border-right: 1px solid ${theme.palette.mode === 'dark' ? '#2f2e4b' : '#eeeeee'};
      border-bottom: 1px solid ${theme.palette.mode === 'dark' ? '#2f2e4b' : '#eeeeee'};
      width: 100%;
      height: 100%;
      display:flex;
      align-items:center;
      justify-content:center;
    }
    .ellipsis-word-class {
      overflow: hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
    }
    .break-word-class {
      overflow-wrap: break-word;
      text-wrap: break-word;
      word-wrap: break-word;
      min-width: 0;
    }
`,
)

export const ReportsSubTableContainer = muiStyled('div')(
  ({ theme, columns = 5, header = false }) => `
    display: grid;
    grid-template-columns: repeat(${columns}, 1fr);
    ${header && `background: ${theme.palette.mode === 'dark' ? '#2f2e4b' : '#eeeeee'};`}
`,
)
